import styled from "styled-components";
import theme from "../styles/theme";
import Button from "./Button";
import FlexBox, { FlexGrow } from "./FlexBox";
import { ClickableIcon } from "./Icon";
import Modal from "./Modal";
import NoButtonSearch from "./NoButtonSearch";
import React, { useState } from "react";
import axios from "axios";
import { StyledText } from "./Text";
import SnackBar from "./SnackBar";

interface State {
  searchTerm: string;
}

type PrerequisiteModalProps = {
  fetchPrereq: () => void;
  prerequisites: any;
  competencyData: any;
  competencies: any;
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  confirmFunction: () => void;
  discardFunction: () => void;
  title: string;
  description: string;
  cancelFunction?: () => void;
  fetchParent?: any;
};
const Title = styled.div`
  gap: 10px;
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
const Flex = styled(FlexGrow)`
  padding: 18px;
  // width: 350px;
  background: #0066ff1a;
  border-radius: 4px;
  margin: 24px 0px;
  color: ${theme.color.darkBlueGray300};
`;
const Competencies = styled("div")`
  overflow-y: scroll;
  height: 300px;
  margin-top: 10px;
  padding: 5px;
  border-radius: 5px;
  font-size: 5px;
`;
const Item = styled("div")`
  padding: 5px;
  cursor: pointer;
  font-size: 14px;
  text-overflow: ellipsis;
  max-width: 330px;
  white-space: nowrap;
  overflow: hidden;
`;
const LabelData = styled(StyledText)`
  color: ${theme.color.lightBlueGray500};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.20000000298023224px;
  text-align: left;
  vertical-align: text-top;
`;
const RadioStyle = styled("div")`
  cursor: pointer;
`;
const CreatePrerequisites = ({
  fetchPrereq,
  prerequisites,
  competencyData,
  competencies,
  isOpen,
  setOpen,
  confirmFunction,
  discardFunction,
  title,
  description,
  fetchParent
}: PrerequisiteModalProps): JSX.Element => {
  const prefix = competencyData.competency_code.slice(0, 3);
  const rawCompetencies: any = [];
  competencies.filter((v: any) => {
    if (v.competency_code.slice(0, 3) === prefix) {
      v.competency_code !== competencyData.competency_code &&
        rawCompetencies.push(v);
    }
  });

  // Create a set of unique values from prerequisites array
  const preReqCodes = new Set(
    prerequisites.map((item: any) => item.prerequisite_competency_code)
  );

  // Subtract preReqCodes from rawCompetencies based on the 'competency_code' property
  const competencyList = competencies.filter(
    (item: any) => !preReqCodes.has(item.competency_code)
  );

  const [searchData, setSearchData] = useState<any>(null);
  const mapData = searchData ? searchData?.filter(
    (item: any) => !preReqCodes.has(item.competency_code)
  ) : competencyList;
  // Filter the data based on the input value

  const [selectedComp, setSelectedComp] = useState<any>();
  const [selectedPrereq, setSelectedPrereq] = useState<any>();
  const [values, setValues] = React.useState<State>({
    searchTerm: "",
  });
  const [isRequired, setIsRequired] = useState<boolean>(true);
  const [message, setMessage] = useState<string>("");
  const [successOpen, setSuccessOpen] = useState<boolean>(false);
  const [errorOpen, setErrorOpen] = useState<boolean>(false);

  const universityCode = localStorage.getItem("university");
  const onSelect = (comp: any) => {
    setSelectedPrereq("");
    setSelectedComp(comp.id);
  };
  const onSelectPrereq = (prereq: any) => {
    setSelectedComp("");
    setSelectedPrereq(prereq.prerequisite_competency_id);
  };
  const addPrereq = () => {
    const data = {
      focus_competency_id: competencyData.id,
      prerequisite_competency_id: selectedComp,
      university_code: universityCode,
      weight: isRequired ? 1 : 0.5,
    };
    axios
      .post(`/competency/prerequisite/new`, data)
      .then((res) => {
        setSelectedComp(null);
        // setSearchData(null);
        // setValues({ searchTerm: "" });
        fetchParent();
        setIsRequired(true);
        fetchPrereq();
        setMessage("Prerequisite added successfully!");
        setSuccessOpen(true);
      })
      .catch((err) => {
        setMessage(err.response.data.error);
        setErrorOpen(true);
      });
  };

  const removePrereq = () => {
    axios
      .delete(
        `/competency/prerequisite/delete?prerequisite_competency_id=${selectedPrereq}&focus_competency_id=${competencyData.id}`
      )
      .then((res) => {
        fetchPrereq();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChange =
    (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setValues({ ...values, [prop]: event.target.value });
      const filtered = competencyList.filter((item: any) =>
        item.competency_code
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      );
      setSearchData(filtered);
    };
  return (
    <>
      <SnackBar
        isOpen={successOpen}
        setOpen={setSuccessOpen}
        message={message}
        type="success"
      />
      <SnackBar
        isOpen={errorOpen}
        setOpen={setErrorOpen}
        message={message}
        type="error"
      />
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: { zIndex: "999999" },
          content: { minWidth: "800px", padding: "0 16px 24px 16px" },
        }}
      >
        <FlexBox style={{ paddingTop: 15 }}>
          <FlexGrow>
            <Title>
              {/* <Icon color="warning">warning_rounded</Icon> */}
              {title}
            </Title>
          </FlexGrow>
          <ClickableIcon
            name="close"
            // color="white"
            onClick={() => setOpen(false)}
          />
        </FlexBox>
        <FlexBox
          style={{ flexWrap: "nowrap" }}
          justify="between"
          alignItems="none"
        >
          <Flex>
            <NoButtonSearch
              setValues={setValues}
              values={values}
              handleChange={handleChange}
              hideButton={true}
              placeholder="Search ..."
              defaultKeyword={""}
              label="Competency code"
              isFullWidth={true}
              onSearch={(keyword: string) => { }}
            />
            <Competencies
              className="visible-scrollbar"
              style={{ background: "#ffffff" }}
            >
              {mapData?.map((comp: any, k: number) => (
                <Item
                  onClick={() => {
                    onSelect(comp);
                  }}
                  style={{
                    background: selectedComp === comp.id ? "#0061ff" : "",
                    color: selectedComp === comp.id ? "#ffffff" : "",
                  }}
                  className="hover"
                  title={comp.title}
                  key={k}
                >
                  {`[${comp.competency_code}] `}
                  {comp.title}
                </Item>
              ))}
            </Competencies>

            <FlexBox
              justify="space-between"
              style={{ marginTop: 18, alignItems: "start" }}
            >
              <div
                style={{
                  // position: "absolute",
                  // background: "white",
                  // color: "gray",
                  borderRadius: 5,
                }}
              >
                <>
                  {/* <RadioStyle
                    className="reduce_opct_onhover"
                    onClick={() => setIsRequired(true)}
                  >
                    <input
                      type="radio"
                      id="yes"
                      // onBlur={onBlur}
                      checked={isRequired}
                      style={{ marginRight: "4px", cursor: "pointer" }}
                    />
                    <LabelData
                      style={{ marginRight: "16px" }}
                      color={theme.color.lightBlueGray500}
                    >
                      Required
                    </LabelData>
                  </RadioStyle> */}
                  {/* <RadioStyle
                    className="reduce_opct_onhover"
                    onClick={() => setIsRequired(false)}
                  >
                    <input
                      type="radio"
                      id="yes"
                      // onBlur={onBlur}
                      checked={!isRequired}
                      // onChange={() => onChange(true)}
                      style={{ marginRight: "4px", cursor: "pointer" }}
                    />
                    <LabelData
                      style={{ marginRight: "16px" }}
                      color={theme.color.lightBlueGray500}
                    >
                      Recommended
                    </LabelData>
                  </RadioStyle> */}
                </>
              </div>
              <Button
                disabled={!selectedComp}
                className={`${selectedComp && "reduce_opct_onhover"}`}
                style={{
                  boxShadow: "0 2px 2px #00000033",
                  width: "151px",
                  // fontSize: 12,
                  color: "#ffffff",
                  background: theme.color.blueButton,
                  border: "none",
                }}
                type="button"
                onClick={() => {
                  addPrereq();
                }}
              >
                + Add
              </Button>
            </FlexBox>
          </Flex>
          <Flex>
            <div style={{ paddingBottom: 16 }}>Existing Prerequisites</div>
            <Competencies
              className="visible-scrollbar"
              style={{ background: "#ffffff" }}
            >
              {prerequisites?.map((prereq: any, k: number) => (
                <Item
                  onClick={() => {
                    onSelectPrereq(prereq);
                  }}
                  style={{
                    background:
                      selectedPrereq === prereq.prerequisite_competency_id
                        ? "#0061ff"
                        : "",
                    color:
                      selectedPrereq === prereq.prerequisite_competency_id
                        ? "#ffffff"
                        : "",
                  }}
                  className="hover"
                  title={prereq.title}
                  key={k}
                >
                  {`[${prereq.prerequisite_competency_code}] `}
                  {
                    competencies.find(
                      (com: any) =>
                        com.competency_code ===
                        prereq?.prerequisite_competency_code
                    )?.title
                  }
                  {/* {prereq.title} */}
                </Item>
              ))}
            </Competencies>
            <FlexBox
              className={`${selectedPrereq && "reduce_opct_onhover"}`}
              justify="end"
              style={{ marginTop: 18 }}
            >
              <Button
                disabled={!selectedPrereq}
                style={{
                  width: "151px",
                  // fontSize: 12,
                  color: "red",
                  // backgroundColor: "#ff3434",
                  border: "2px solid red",
                }}
                isOutline
                type="button"
                onClick={() => {
                  removePrereq();
                }}
              >
                Remove
              </Button>
            </FlexBox>
          </Flex>
        </FlexBox>
        <FlexBox justify="end">
          <Button
            className={"reduce_opct_onhover"}
            style={{
              boxShadow: "0 2px 2px #00000033",
              width: "151px",
              // fontSize: 12,
              color: "#ffffff",
              background: theme.color.blueButton,
              border: "none",
            }}
            type="button"
            onClick={() => {
              setOpen(false);
            }}
          >
            Done
          </Button>
        </FlexBox>
      </Modal>
    </>
  );
};

export default CreatePrerequisites;
